import { useSelector } from 'react-redux';
import { array } from 'fp-ts';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { ApplicationState, OrderItem } from '@mews-commander/types';
import { ConvertedCurrencyValue } from '@mews-commander/ui';
import {
    isCurrentEnterpriseInMultiTaxEnvironment,
    getCurrentEnterpriseDefaultCurrencyCode,
} from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { getOrderItemsTotalAmount } from '@mews-commander/legacy-entities/src/selectors/orderItems';
import { getServiceTimeUnitPluralKey } from '@mews-commander/legacy-entities/src/utils/serviceTimeUnitLocalization';
import { ProductOrderGroup } from '../../../transformProductOrders/types';
import TogglableList from './TogglableList';
import CountLabel from './CountLabel';
import { ProductOrderGroupRow } from './ProductOrderGroupRow';

interface Props {
    serviceId: string;
    groups: ProductOrderGroup[];
    productOrders: OrderItem[];
}

const ProductOrdersGrid = ({ serviceId, groups, productOrders }: Props) => {
    const defaultCurrencyCode: string = useSelector(getCurrentEnterpriseDefaultCurrencyCode);
    const isMultiTaxEnvironment: boolean = useSelector(isCurrentEnterpriseInMultiTaxEnvironment);
    const productOrderTotalAmount = getOrderItemsTotalAmount(productOrders, defaultCurrencyCode);
    const timeUnitKey = useSelector((state: ApplicationState) => getServiceTimeUnitPluralKey(state, { id: serviceId }));

    return array.isNonEmpty(productOrders) && timeUnitKey !== undefined ? (
        <TogglableList
            label={
                <CountLabel
                    count={array.size(productOrders)}
                    item={<LocalizedText textKey={TextKey.ProductPlural} />}
                />
            }
            additionalInfo={<ConvertedCurrencyValue amount={productOrderTotalAmount} net={isMultiTaxEnvironment} />}
        >
            {groups.map((group) => (
                <ProductOrderGroupRow
                    group={group}
                    isMultiTaxEnvironment={isMultiTaxEnvironment}
                    timeUnitKey={timeUnitKey}
                    key={group.id}
                />
            ))}
        </TogglableList>
    ) : null;
};

export default ProductOrdersGrid;
